declare namespace $ {

	export class $mol_icon_chart_bar extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=bar.view.tree.d.ts.map